import appService from '../js/appservice/index'
import { getErrorMessage } from '../js/helpers/storehelper'

const actions = {
  exportTestData(context, data) {
    return new Promise((resolve, reject) => {
      appService.testdata
        .exportTestData(data)
        .then(data => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}

export default {
  namespaced: true,
  actions
}
